export default __webpack_public_path__ + "92a4f164.png";